'use client';
import { onSameLevel } from './utils/onSameLevel/onSameLevel.js';
import { getNextIndex } from './utils/getNextIndex/getNextIndex.js';
import { getPreviousIndex } from './utils/getPreviousIndex/getPreviousIndex.js';

// TODO: описать назначение
// TODO: move system
function createScopedKeydownHandler(options) {
    var parentSelector = options.parentSelector, siblingSelector = options.siblingSelector, onKeyDown = options.onKeyDown, _options_loop = options.loop, loop = _options_loop === void 0 ? true : _options_loop, _options_activateOnFocus = options.activateOnFocus, activateOnFocus = _options_activateOnFocus === void 0 ? false : _options_activateOnFocus, _options_dir = options.dir, dir = _options_dir === void 0 ? "rtl" : _options_dir, orientation = options.orientation;
    return function(event) {
        var _event_currentTarget_closest;
        onKeyDown == null ? void 0 : onKeyDown(event);
        var elements = Array.from(((_event_currentTarget_closest = event.currentTarget.closest(parentSelector)) == null ? void 0 : _event_currentTarget_closest.querySelectorAll(siblingSelector)) || []).filter(function(node) {
            return onSameLevel(event.currentTarget, node, parentSelector);
        });
        var current = elements.findIndex(function(element) {
            return event.currentTarget === element;
        });
        var _nextIndex = getNextIndex(current, elements, loop);
        var _previousIndex = getPreviousIndex(current, elements, loop);
        var nextIndex = dir === "rtl" ? _previousIndex : _nextIndex;
        var previousIndex = dir === "rtl" ? _nextIndex : _previousIndex;
        switch(event.key){
            case "ArrowRight":
                {
                    if (orientation === "horizontal") {
                        event.stopPropagation();
                        event.preventDefault();
                        elements[nextIndex].focus();
                        if (activateOnFocus) {
                            elements[nextIndex].click();
                        }
                    }
                    break;
                }
            case "ArrowLeft":
                {
                    if (orientation === "horizontal") {
                        event.stopPropagation();
                        event.preventDefault();
                        elements[previousIndex].focus();
                        if (activateOnFocus) {
                            elements[previousIndex].click();
                        }
                    }
                    break;
                }
            case "ArrowUp":
                {
                    if (orientation === "vertical") {
                        event.stopPropagation();
                        event.preventDefault();
                        elements[_previousIndex].focus();
                        if (activateOnFocus) {
                            elements[_previousIndex].click();
                        }
                    }
                    break;
                }
            case "ArrowDown":
                {
                    if (orientation === "vertical") {
                        event.stopPropagation();
                        event.preventDefault();
                        elements[_nextIndex].focus();
                        if (activateOnFocus) {
                            elements[_nextIndex].click();
                        }
                    }
                    break;
                }
            case "Home":
                {
                    event.stopPropagation();
                    event.preventDefault();
                    if (!elements[0].disabled) {
                        elements[0].focus();
                    }
                    break;
                }
            case "End":
                {
                    event.stopPropagation();
                    event.preventDefault();
                    var last = elements.length - 1;
                    if (!elements[last].disabled) {
                        elements[last].focus();
                    }
                    break;
                }
        }
    };
}

export { createScopedKeydownHandler };
